<template>
    <div class="c-cocon-list">
        <BackButton />

        <div class="inner-content full">
            <h1>{{$t('cocon_list.title')}}</h1>
            <div class="cocon-info">
				<div v-if="socketConnected">
					Verbonden met locale server
				</div>
				<div v-if="!socketConnected && isInShop">
					Verbonden met cocon via cloud server
				</div>

			</div>
            <div class="content">
                <div class="cocon-list">
                    <div v-for="cocon, idx in status" :key="cocon.id" class="item">
                        <div>
                            <b>{{$t('cocon_list.list_item', {cocon: idx+1})}}</b>
                        </div>
                        <div>
                            {{$t('cocon_list.bed_connected')}} :
                            <span v-if="cocon.bed_service_connected">{{$t('generic.yes')}}</span>
                            <span v-else>{{$t('generic.no')}}</span>
                        </div>
                        <div>
                            {{$t('cocon_list.cocon_connected')}} :
                            <span v-if="cocon.socket_id !== null">{{$t('generic.yes')}}</span>
                            <span v-else>{{$t('generic.no')}}</span>
                        </div>
                        <div class="volume-controls" v-if="cocon.bed_service_connected">
                            <div class="slider">
                                <input type="range" class="slider" min="0" max="100" v-model.number="volumes[idx]"
                                    v-on:change="changeVolume(idx)" />
                            </div>
                            <div class="volume">
                                {{volumes[idx]}}%
                            </div>
                        </div>
                    </div>
                </div>
                <div class="error-list" v-if="bedErrors.length > 0">
                    <b>Recenste bed meldingen:</b>
                    <div v-for="error in bedErrors" :key="error.ts" class="error-item">
                        {{formatTime(error.ts)}} :
                        {{error.errorType}}:
                        {{getErrorMessage(error)}}
                    </div>
                </div>
            </div>
            <div v-if="status.length == 0">
                <p>
                    {{$t('cocon_list.cocons_not_connected')}}
                </p>
                <p>
                    coconIp: {{coconIp}}
                </p>
                <p>
                    browserIp: {{browserIp}}
                </p>
                <p>
                    <a :href="socketHost" target="_blank">View socket status</a>
                </p>
            </div>
            <div class="btns">
                <button class="btn-basic bordered" @click.prevent="sendShutDown()" >
                    {{$t('cocon_list.shutdown')}}
                </button>

                <button class="btn-basic bordered" @click.prevent="clickReload()" >
                    {{$t('cocon_list.reload')}}
                </button>

                <ServiceMeasurement v-if="loggedInUser && loggedInUser.role === 'service'"/>
            </div>
        </div>
    </div>
</template>

<script>
import BackButton from "@/components/app/BackButton.vue";
import ServiceMeasurement from "@/components/measurements/ServiceMeasurement.vue";
import CoconMixin from "@/mixins/CoconMixin";
import LoginMixin from "@/mixins/LoginMixin";
import {measurementStore} from "@/stores/measurement";
import {socketStore} from "@/stores/socket";

export default {
    name : "CoconList",

    components: {
        BackButton,
        ServiceMeasurement
    },

    mixins: [
        CoconMixin, LoginMixin
    ],

    data() {
        return {
            volumes: []
        };
    },

    watch: {
        status() {
            if (this.volumes.length === 0) {
                this.status.forEach((status, i) => {
                    this.volumes[i] = status.volume;
                });
            }
        }
    },

    computed: {
        socketHost() {
            return socketStore().host + ":" + socketStore().port;
        },

        bedErrors() {
            const errors = this.status.map(x => x.bed_errors)
                .flat()
                .slice(0, 20);
            errors.sort((a, b) => a.ts && b.ts && (a.ts > b.ts ? -1 : 1));
            return errors;
        },

        coconIp() {
            return measurementStore().coconIp;
        },

        browserIp() {
            return measurementStore().browserIp;
        }
    },

    methods: {
        changeVolume(cocon) {
            measurementStore().setVolume(cocon, parseInt(this.volumes[cocon]));
        },

        sendShutDown() {
            measurementStore().shutdownCocon();
        },

        clickReload() {
            location.reload();
        },

        formatTime(timestamp) {
            const date = new Date(timestamp * 1000);

            return date.toLocaleTimeString("nl-NL");
        },

        getErrorMessage(error) {
            const key = "bed_errors." + error.errorType.replace(".", "_");
            if (this.$te(key)) {
                return this.$t(key);
            }
            return error.errorDesc;
        }
    }
};
</script>

<style lang="scss" scoped>
    .c-cocon-list {
        height : 100%;
    }

    .item {
        margin-bottom: 3rem;
    }

    .cocon-info {
        margin-bottom : 2rem;
    }

    .content {
        display: flex;
    }

    .cocon-list {
        width : 50%;
    }

    .error-list {
        width : 35%;
        margin-left: 10%;

        .error-item {
            margin-top: .25rem;
        }
    }

    .btns {
        margin-top: 2rem;

        & > * {
            margin-bottom: 1rem;
            margin-right: 0.5rem;
        }
    }

    .slider {
        width: 100%;
        height: 1rem;
        position: relative;
        background: #D7DBE0;
        border-radius: 4rem;
    }

    .volume-controls {
        display:flex;
        margin-top:1rem;
        margin-bottom:1.5rem;

        .volume {
            margin: 0 .35rem;
        }
    }
</style>